export default function initFancybox() {
    Fancybox.bind("[data-fancybox]", {});
}
